import { __assign } from "tslib";
import React from 'react';
import { Box, Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsBorderItem, SpecsPanelProperty, } from '@marvelapp/ui-internal';
import ColorFill from './sidebar/ColorFill';
import GradientFill from './sidebar/GradientFill';
import Measurement from '../../containers/handoff/Measurement';
export default function PanelBorder(_a) {
    var borders = _a.borders;
    var header = 'Border';
    if (borders.length > 1) {
        header += 's';
    }
    return (React.createElement(SpecsPanel, { title: header }, borders.map(function (border, index) { return (React.createElement(SpecsBorderItem, { flexDirection: "column", 
        // eslint-disable-next-line react/no-array-index-key
        key: index, marginBottom: 20, paddingBottom: 20 },
        border.type === 'color' ? (React.createElement(ColorFill, __assign({}, border))) : (React.createElement(GradientFill, __assign({}, border))),
        React.createElement(Flex, { marginTop: 10 },
            React.createElement(Box, { width: 1 / 4 },
                React.createElement(SpecsPanelProperty, { label: "Position" }, border.position)),
            React.createElement(Box, { width: 1 / 4 },
                React.createElement(SpecsPanelProperty, { label: "Weight" },
                    React.createElement(Measurement, { includeUnitIfZero: true, value: border.width })))))); })));
}
